export const PLAN_SECTION_NAVIGATE_EVENT = 'retira:plan-section-navigate'

export function navigateToPlanSection(section) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(PLAN_SECTION_NAVIGATE_EVENT, { detail: { section } }))
}
